module.exports = __webpack_public_path__ + "static/profile-page-20e39d0c0908754101ebfce7586ee8d4.png";